import React from 'react';
import { MdAdd, MdSettings, MdFilterList, MdSearch, MdPerson, MdVisibility } from 'react-icons/md';
import ReactPaginate from 'react-paginate';
import TableLoadingWrapper from './TableLoadingWrapper';
import '../styles/views.css';

const UsersView = ({
  pagedFilteredData,
  searchTerm,
  setSearchTerm,
  pageCount,
  handlePageClick,
  setIsAddUserModalOpen,
  setEditUser,
  setIsEditModalOpen,
  currentPage,
  totalRows,
  itemsPerPage,
  statusFilter,
  setStatusFilter,
  loading,
  onManageSidebar, // New prop for sidebar management
}) => {




  return (
    <>
      {/* Header Section */}
      <div style={{
        marginBottom: 24,
        borderRadius: 12,
      }}>
        <div style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          marginBottom: 16
        }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
            <MdPerson size={20} style={{color: '#1976d2'}}/>
            <h3 style={{ margin: 0, color: '#333', fontSize: 18, fontWeight: '600' }}>
              System Users Management
            </h3>
          </div>

          <button
            onClick={() => setIsAddUserModalOpen(true)}
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: 8,
              padding: '10px 16px',
              backgroundColor: '#1976d2',
              color: 'white',
              border: 'none',
              borderRadius: 8,
              cursor: 'pointer',
              fontSize: 14,
              fontWeight: '600',
              boxShadow: '0 2px 4px rgba(25, 118, 210, 0.3)',
              transition: 'all 0.2s ease'
            }}
            onMouseEnter={e => {
              e.currentTarget.style.backgroundColor = '#1565c0';
              e.currentTarget.style.transform = 'translateY(-1px)';
              e.currentTarget.style.boxShadow = '0 4px 8px rgba(25, 118, 210, 0.4)';
            }}
            onMouseLeave={e => {
              e.currentTarget.style.backgroundColor = '#1976d2';
              e.currentTarget.style.transform = 'translateY(0)';
              e.currentTarget.style.boxShadow = '0 2px 4px rgba(25, 118, 210, 0.3)';
            }}
          >
            <MdAdd size={18} />
            Add New User
          </button>
        </div>

        {/* Search and Filter Controls */}
        <div style={{ display: 'flex', alignItems: 'center', gap: 16, flexWrap: 'wrap' }}>
          <div style={{ position: 'relative', flex: '1', minWidth: 300 }}>
            <MdSearch size={20} style={{
              position: 'absolute',
              left: 12,
              top: '50%',
              transform: 'translateY(-50%)',
              color: '#666'
            }} />
            <input
              type="text"
              placeholder="Search users by name, email, or role..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              style={{
                width: '100%',
                padding: '10px 12px 10px 40px',
                borderRadius: 8,
                border: '1px solid #ddd',
                fontSize: 14,
                outline: 'none',
                transition: 'border-color 0.2s ease',
                boxSizing: 'border-box'
              }}
              onFocus={e => e.target.style.borderColor = '#1976d2'}
              onBlur={e => e.target.style.borderColor = '#ddd'}
            />
          </div>

          <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
            <MdFilterList size={20} style={{ color: '#666' }} />
            <select
              value={statusFilter}
              onChange={(e) => setStatusFilter(e.target.value)}
              style={{
                padding: '10px 12px',
                borderRadius: 8,
                border: '1px solid #ddd',
                fontSize: 14,
                outline: 'none',
                backgroundColor: '#fff',
                cursor: 'pointer',
                minWidth: 120
              }}
            >
              <option value="All">All Status</option>
              <option value="active">Active</option>
              <option value="inactive">Inactive</option>
              <option value="suspended">Suspended</option>
            </select>
          </div>
        </div>
      </div>

      {/* Users Table - MMDA Management Style */}
      <TableLoadingWrapper loading={loading}>
        <div style={{ overflowX: 'auto' }}>
          <table>
            <thead>
              <tr>
                <th>Role</th>
                <th>Full Name</th>
 
                <th>Status</th>
                <th>MMDA Name</th>

                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {pagedFilteredData.map((row, i) => (
                <tr key={i} style={{ cursor: 'default' }}>
                  <td>
                    <span style={{
                      padding: '4px 8px',
                      backgroundColor: '#e3f2fd',
                      borderRadius: 4,
                      fontSize: 12,
                      fontWeight: 'bold',
                      color: '#1976d2'
                    }}>
                      {(() => {
                        const roleName = row.role_name || row.role_id || 'Unknown Role';
                        return String(roleName).replace(/_/g, ' ');
                      })()}
                    </span>
                  </td>
                  <td>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                      <strong>{row.full_name}</strong>
                    </div>
                  </td>

                  <td>
                    <span style={{
                      padding: '4px 8px',
                      backgroundColor: row.status === 'active' ? '#e8f5e8' : row.status === 'inactive' ? '#ffebee' : '#fff3cd',
                      color: row.status === 'active' ? '#2e7d32' : row.status === 'inactive' ? '#c62828' : '#856404',
                      borderRadius: 4,
                      fontSize: 12,
                      fontWeight: 'bold'
                    }}>
                      {(row.status || '').charAt(0).toUpperCase() + (row.status || '').slice(1)}
                    </span>
                  </td>
                  <td>{row.mmda_name}</td>

                  <td>
                    <div style={{ display: 'flex', gap: 8 }}>
                      <button
                        onClick={() => {
                          setEditUser(row);
                          setIsEditModalOpen(true);
                        }}
                        style={{
                          padding: '6px 12px',
                          backgroundColor: '#1976d2',
                          color: 'white',
                          border: 'none',
                          borderRadius: 4,
                          cursor: 'pointer',
                          fontSize: 12,
                          display: 'flex',
                          alignItems: 'center',
                          gap: 4
                        }}
                      >
                        <MdSettings size={14} />
                        Edit
                      </button>

                      {/* Manage Sidebar Button - Only show for MMDA and SuperAdmin roles */}
                      {(row.role_name === 'MMDA' || row.role_name === 'mmda' || row.role_name === 'super_admin') && onManageSidebar && (
                        <button
                          onClick={() => onManageSidebar(row)}
                          style={{
                            padding: '6px 12px',
                            backgroundColor: '#4caf50',
                            color: 'white',
                            border: 'none',
                            borderRadius: 4,
                            cursor: 'pointer',
                            fontSize: 12,
                            display: 'flex',
                            alignItems: 'center',
                            gap: 4
                          }}
                          title="Manage sidebar visibility for this user"
                        >
                          <MdVisibility size={14} />
                          Roles
                        </button>
                      )}
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </TableLoadingWrapper>

      {/* Enhanced Pagination */}
      {pageCount > 1 && (
        <div style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          marginTop: 24,
          padding: '20px',
          backgroundColor: '#fff',
          borderRadius: 12,

          border: '1px solid #f0f0f0'
        }}>
          <ReactPaginate
            previousLabel={'← Previous'}
            nextLabel={'Next →'}
            breakLabel={'...'}
            pageCount={pageCount}
            marginPagesDisplayed={2}
            pageRangeDisplayed={5}
            onPageChange={handlePageClick}
            containerClassName={'pagination'}
            activeClassName={'active'}
            pageClassName={'page-item'}
            pageLinkClassName={'page-link'}
            previousClassName={'page-item'}
            previousLinkClassName={'page-link'}
            nextClassName={'page-item'}
            nextLinkClassName={'page-link'}
            breakClassName={'page-item'}
            breakLinkClassName={'page-link'}
          />
          <div style={{
            marginLeft: 20,
            color: '#666',
            fontSize: 14,
            fontWeight: '500'
          }}>
            Showing {currentPage * itemsPerPage + 1} - {Math.min((currentPage + 1) * itemsPerPage, totalRows)} of {totalRows} users
          </div>
        </div>
      )}
    </>
  );
};

export default UsersView;
